module.exports = __webpack_public_path__ + "11a8a8e3ced52265e3d2348e51ab646e.jpg";